






























import {
  ref,
  useContext,
  useRoute,
  defineComponent,
  onBeforeMount,
  computed,
  useRouter,
  watch
} from '@nuxtjs/composition-api';
import { merge } from 'lodash-es';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import {  useUiNotification } from '~/composables';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import type { ProductForProductPageType } from '~/utils/types/ProductPage';
import axios from "axios";
import useLoader from '~/composables/useLoader';
import ProductFrequencySwitcher from '~/components/product-page/ProductFrequencySwitcher.vue';
import useProductPage from '~/composables/useProductPage';
import ChooseProductConfigurations from '~/components/product-page/ChooseProductConfigurations.vue';
import StickyBottom from '~/components/product-page/StickyBottom.vue';
import Features from '~/components/product-page/Features.vue';
import Quesiti from '~/components/product-page/Quesiti.vue';
import ProductAddPaperCheckbox from '~/components/product-page/ProductAddPaperCheckbox.vue';
import ModulesToAdd from '~/components/product-page/ModulesToAdd.vue';
import RequiredModules from '~/components/product-page/RequiredModules.vue';
import { CONFIGURABLE_TYPE_ID, VIRTUAL_TYPE_ID } from '~/utils/constants/product';
import Error from "~/components/404Error.vue";
import { pageView } from '~/helpers/trackings/product';
import { formatDate } from '~/utils/helpers/functions';
export default defineComponent({
  props: {
      slug: {
          type: String,
          required: true
      },
      sku: {
          type: String,
          required: false
      }
  },
  name: 'ProductPage',
  layout: 'product',
  components: {
    LoadWhenVisible,
    ProductFrequencySwitcher,
    ChooseProductConfigurations,
    StickyBottom,
    Features,
    Quesiti,
    ProductAddPaperCheckbox,
    ModulesToAdd,
    RequiredModules,
    Error,
  },
  transition: 'fade',
  setup(props, context) {
    const route = useRoute();
    const { send: sendNotification } = useUiNotification();
    const { setIsLoading, isLoading } = useLoader();
    const { product, setProduct, showPaymentFrequencySwitcher, addToCartConfigs, offset, paymentFrequencyChoosen, setPaymentFrequencyChoosen } = useProductPage();
    const {app : { i18n }, $config } = useContext();
    const hasPaymentFrequencySwitcher = ref<Boolean>(false);
    const router = useRouter();
    const trackPageView = async (product)=>{
      /*don't await, async transparent service*/ pageView(product, route.value.query.utm_campaign || $config.utmCampaignDefault, paymentFrequencyChoosen.value);
    }
    const fetchProductData = async () => {
      setIsLoading(true);
      
      try{
        const splittedRoute = props.slug.split('/product');
        const routeEnding = splittedRoute[1] ? splittedRoute[1]:splittedRoute[0];
        const urlKey = routeEnding.split('.')[0].replace('/','');
        const queryParams = new URLSearchParams({ urlKey, sku: props.sku }).toString();

        const { data } = await axios.get(
          `/sole-api/product/getProduct?${queryParams}`
        );
        
        const tmp : ProductForProductPageType = merge({}, data as ProductForProductPageType ?? null);
       
        setProduct(tmp);
        trackPageView(tmp)          
      }catch(e){
        sendNotification({
          id: Symbol("product_not_found"),
          message: i18n.t("An error occurred retrieving this product") as string,
          type: "danger",
          icon: "cross",
          persist: true,
        });
        console.error(e)
      }
      setIsLoading(false);
    };
    const productLoadingDone = ref<Boolean>(false)
    onBeforeMount(async () => {
      await fetchProductData();
      if(product.value && product.value.customizable_options && product.value.customizable_options.find(el=>el.title=='data_uscita') && !route.value.query.copyDate){
        const today = new Date();
        const copyDate = `${today.getFullYear()}${(today.getMonth()+1+'').padStart(2,'0')}${today.getDate()}`
        await router.replace({query: {sku:product.value.sku, copyDate}})
      }
      productLoadingDone.value = true;
      /**
       * Has frequency switcher only if there are frequencies or there is tipo_abbonamento 
       */
        if(product.value){
          hasPaymentFrequencySwitcher.value = (product.value.productTypeId==CONFIGURABLE_TYPE_ID && product.value.configurable_options.find(el=>el.attribute_code=='tipo_abbonamento')) || !!product.value.paymentFrequencies[0];
        }
      });
  
      const landingRoute = computed(()=>{
        if(!product.value) return '';
        return `/landing/${route.value.query.utmCampaign || route.value.query.utm_campaign ||''}`;
      })
      const linkDatas = computed(()=>{
        if(!product.value) return {};
        return product.value.urlSubscriptionOptions ? { href : product.value.urlSubscriptionOptions} : {to: landingRoute.value}
      })
  
      const isVirtual = computed(()=>{
        return product.value?.productTypeId == VIRTUAL_TYPE_ID
      })
      const isWithDaysExpiration = computed(() => {
        return {
          hasCancellationPeriod: product.value?.cancellation_notice_days !== 0 && product.value?.cancellation_notice_days !== null,
          value: product.value?.cancellation_notice_days
        };
      });
      
      watch(product, () => {
        if(!product){
          return;
        }
        if(product.value.entryBillingPeriod && product.value.entryBillingPeriod !== undefined && product.value.entryBillingPeriod !== null){
          setPaymentFrequencyChoosen(product.value?.entryBillingPeriod);
        }
      })

    return {
      product,
      isLoading,
      productLoadingDone,
      showPaymentFrequencySwitcher,
      addToCartConfigs,
      linkDatas,
      isVirtual,
      customStyle : computed(()=>{ return {marginBottom : offset.value+'px'}}),
      hasPaymentFrequencySwitcher,
      copyDate: route.value.query.copyDate ? formatDate(route.value.query.copyDate,'YYYYMMDD','/'):null,
      isWithDaysExpiration
    };
  }
  /*head() {
    return getMetaInfo(this.product);
  },*/
});
